import { Environments } from '@/enums';
import * as Development from './api-endpoints/development';
import * as Production from './api-endpoints/production';
import * as Staging from './api-endpoints/staging';

export const PLACEHOLDER_IMAGES = {
  DEFAULT_OG_IMAGE: '/images/apex_logo.png',
};

export const REGEX = {
  VALID_NAME: /^(?!\s{3,}$).*/,
  VALID_PHONE: /(^(\+8801|8801|01|008801))[1|3-9]{1}(\d){8}$/,
  VALID_URL:
    /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
  VALID_EMAIL:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
  VALID_UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  VALID_SHORTENED_URL: /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/i,
  VALID_NUMBER: /^[0-9]+$/,
  REPLACE_WHITESPACE: /\s{2,}/gi,
  REPLACE_BETWEEN_WHITESPACE: /\s+/g,
  VALID_ADDRESS: /^.{10,}$/,
};

const getApiUrl = () => {
  let returnVal = Production.APEX_API_URL;
  switch (process.env.NEXT_PUBLIC_APP_ENVIRONMENT) {
    case Environments.Production:
      returnVal = Production.APEX_API_URL;
      break;
    case Environments.Staging:
      returnVal = Staging.APEX_API_URL;
      break;
    case Environments.Development:
      returnVal = Development.APEX_API_URL;
      //returnVal = Staging.APEX_API_URL;
      break;
    case Environments.Local:
      // returnVal = Development.APEX_API_URL;
      returnVal = Production.APEX_API_URL;
      // returnVal = Staging.APEX_API_URL;

      break;
  }
  return returnVal;
};

const getMailChimpApiUrl = () => {
  let returnUrl = Production.APEX_MAIL_CHIMP_URL;
  switch (process.env.NEXT_PUBLIC_APP_ENVIRONMENT) {
    case Environments.Production:
      returnUrl = Production.APEX_MAIL_CHIMP_URL;
      break;
    case Environments.Staging:
      returnUrl = Staging.APEX_MAIL_CHIMP_URL;
      break;
    case Environments.Development:
      returnUrl = Development.APEX_MAIL_CHIMP_URL;
      break;
    case Environments.Local:
      returnUrl = Staging.APEX_MAIL_CHIMP_URL;
      break;
  }
  return returnUrl;
};

export const APP_URL = 'https://www.apex4u.com';
export const APP_TITLE = 'Apex';
export const APP_DESCRIPTION =
  'Apex footwear brings you an exclusive range of shoes, slippers, sandals, and clothing for men, women & kids. Buy shoes online and enroll in loyalty programs';
export const APP_META_KEYWORDS = '';
export const SESSION_STALE_TIME = 60 * 1000 * 50; //50 min
export const REFRESH_ACCESS_TOKEN_ERROR_STRING = 'RefreshAccessTokenError';
export const REDIRECT_BY_RTK_ERROR_STRING = 'redirected-by-react-query';
export const Empty_Guid = '00000000-0000-0000-0000-000000000000';
export const APEX_API_URL = getApiUrl();
export const OTP_RESEND_TIMEOUT = 180000;
export const EMAIL_RESEND_TIMEOUT = 60000;
export const APEX_WP_URL = 'https://wordpress.apex4u.com';
export const CDN =
  process.env.NEXT_PUBLIC_APP_ENVIRONMENT === Environments.Production ? 'https://storage.apex4u.com' : 'https://d2i3tcjf11a3n5.cloudfront.net';
// export const CDN = 'https://d2i3tcjf11a3n5.cloudfront.net';
// export const CDN = 'https://apex4u-style-images.s3.ap-southeast-1.amazonaws.com';
export const WP_REVALIDATE_TIME = 120; // 120 seconds
export const Default_Image = '/images/product_default_img.png';
export const apex_logo = '/images/apex-logo.png';
export const RVI_LS_PROPERTY_NAME = 'recently-viewed-items';
export const BANGLADESH_LONGITUDE = 90.3563;
export const BANGLADESH_LATITUDE = 23.685;
export const base64Image = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsSAAALEgHS3X78AAAAAXNSR0IArs4c6QAAAwhJREFUaEPtWNlS4kAUPQkJoDUOKDuK//9dLCooCXsgCcnUuQrFPExB99iONdX9lEr63tyzdVDnNQhz/AfLsUC+mYpWkW8mCKwiVhFDDFhrGSJWu61VRJs6Q4VWEUPEare1imhTZ6jQKmKIWO22f6XIPk2RJAlc10WxVNIe4jMKtYG4joPxeIztdgvHcdB7fESe/7u/mrWBcPhBv38cvt1uwy8WP4NcrR7KQAiAi0pMxmP4vi/2ur29xY+bG1CpLM9RcF3EcYxCoQDHdQWwVDoO0iQ53keeQ3Skmo5zrOdeFX2VgeRZhtlsJoNkWYZisYjpdIqrqys0Gg25NxwO4XmeDL/f71FvNHB9fS0AXl5exIp8Vq1WUS6X8fT0JDmjPUlOFEXodDrwfP9idZSAcIAo2iDaRNjtdjJQq9WSQQiAg2T7vQAhMD57fn4Wxbr39wimU2w2G9m3XCwwn8/R6/UwmUxEYQIjSQTXbLWUMqcEhPKvVivESSzDpUkqjFUqFSyXS9TqdfiedwTSaDYxn81kYIJ6e3uT/d1uF+v1GkEQ4O7uTuzJg+OgFPeqnoJKQLZRJC8rlctYr1YygORltxVD0z603EERAiHzYRiK7WhBKnd6ujFblWoVo+EQaZqKJe8fHmSfylICwnyQeQ5LNg8B50sJrFQqySCj0eg9M80mZmGIxWIBnmoEwizw+gjGcZDEsViQtQSjmg85Q1T/08hTiRahNdqdjqjCe/1+X4akbQaDgQCp1+syIAPPLND/JOLUOlT4dTKR7LCWFiMhcnAofJe0gNA6h3CTWQLhacTAkk1eny5mh7bj0GEQyKnEOipLVTk8A06ABMtMEVTB8y52lzIQDvP+JcFvjBEMF9k/ZKRWq4lKp98Dqf/YK9+Oj8Ur+db8of85RMpAzjVkjg5A+P34qmUECDNEn/+sVL4Kh3rYL5lM9efFJT3P7fl0Rc690NRzC8QUs7p9rSK6zJmqs4qYYla3r1VElzlTdVYRU8zq9rWK6DJnqs4qYopZ3b5WEV3mTNX9An1kKi+ZAZ1qAAAAAElFTkSuQmCC`;
export const APEX_MAIL_CHIMP_API_URL = getMailChimpApiUrl();

export const GOOGLE_CLIENT_ID = '1009910881119-9e4oo7kft9jmm6ip14fdsl0224l501hn.apps.googleusercontent.com';
export const GOOGLE_CLIENT_SECRET = 'u3tUb65EhKMPBkhtRzFtUSf6';

export const FB_APP_ID = '262748369804872';
export const FB_APP_SECRET = 'dd97a688e5ecff1bd1305711154d0a65';
export const G_TAG_MANAGER_ID = 'GTM-5L47XHS';
declare const window: any;
export const dataLayer: any = typeof window !== 'undefined' ? window?.dataLayer : undefined;
export const DYNAMIC_LOAD_TIMEOUT = 50;
export const forceRefreshQuery = 'forcerefresh';
